import { Link } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
import { ThemeToggle } from '@/components/ThemeToggle';

export function Landing() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-6 bg-background text-foreground relative">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <div className="max-w-xl text-center space-y-6">
        <div className="mx-auto flex size-14 items-center justify-center rounded-2xl bg-primary text-primary-foreground">
          <TrendingUp className="size-7" />
        </div>
        <h1 className="text-4xl font-bold tracking-tight">RepairPulse</h1>
        <p className="text-muted-foreground">
          Multi-tenant credit-repair platform. Dispute rounds, monthly diffing,
          reinsertion detection, and server-side PDF letters — all gated by
          PostgreSQL row-level security.
        </p>
        <div className="flex gap-3 justify-center pt-2">
          <Link
            to="/login"
            className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
          >
            Sign in
          </Link>
          <Link
            to="/register-agency"
            className="inline-flex items-center rounded-md border border-border px-4 py-2 text-sm font-medium hover:bg-accent"
          >
            Register agency
          </Link>
        </div>
        <p className="text-xs text-muted-foreground pt-4">
          Hito 0 baseline · docker compose up · Postgres + NestJS + Vite + Caddy
        </p>
      </div>
    </main>
  );
}